// FILE: src/components/kyb/ui/EmptyStateCard.tsx
// PURPOSE: Consistent empty state component matching the layout of data cards

import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  gradientFrom?: string;
  gradientTo?: string;
  iconColor?: string;
}

export const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  icon: Icon,
  title,
  description,
  gradientFrom = 'from-slate-600',
  gradientTo = 'to-slate-800',
  iconColor = 'text-slate-400'
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
      {/* Header matching your existing card style */}
      <div className={`bg-gradient-to-r ${gradientFrom} ${gradientTo} px-6 py-4`}>
        <div className="flex items-center gap-3">
          <Icon className="w-6 h-6 text-white/70" />
          <h3 className="text-xl font-bold text-white/70">{title}</h3>
        </div>
      </div>
      
      {/* Content area with consistent height */}
      <div className="p-6">
        <div className="min-h-[200px] flex flex-col items-center justify-center text-center">
          <div className="p-4 bg-slate-50 rounded-full mb-4">
            <Icon className={`w-12 h-12 ${iconColor}`} />
          </div>
          <p className="text-slate-500 font-medium mb-2">No Data Available</p>
          <p className="text-sm text-slate-400 max-w-md">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};